<script lang="ts">
	import { _ } from "svelte-i18n";
	import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@sveltestrap/sveltestrap";
	import type { Suggestion } from "../../../common/types";

	let {
		isOpen = $bindable(false),
		suggestions,
		onSelect,
	}: {
		isOpen?: boolean;
		suggestions: Array<Suggestion>;
		onSelect?: (suggestion: string) => void;
	} = $props();

	let selected = $state("");

	// Reset selected when re-opened with a different/refreshed suggestions list.
	$effect(() => {
		if (isOpen && suggestions.length > 0) {
			const stillValid = suggestions.some((s) => s.suggestion === selected);
			if (!stillValid) {
				selected = suggestions[0].suggestion;
			}
		}
	});

	function onUse() {
		onSelect?.(selected);
	}

	function close() {
		isOpen = false;
	}
</script>

<Modal {isOpen} toggle={close}>
	<ModalHeader toggle={close}>
		{$_("landingpage.newPresentation.useSuggestion")}
	</ModalHeader>
	<ModalBody>
		<select class="form-select" bind:value={selected}>
			{#each suggestions as s (s.id)}
				<option value={s.suggestion}>{s.suggestion}</option>
			{/each}
		</select>
	</ModalBody>
	<ModalFooter>
		<Button color="secondary" on:click={close}>
			{$_("landingpage.newPresentation.cancel")}
		</Button>
		<Button color="primary" on:click={onUse} disabled={!selected}>
			{$_("landingpage.newPresentation.useSelectedSuggestion")}
		</Button>
	</ModalFooter>
</Modal>
